import React, { Component } from 'react';

export default class FailTransaction extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="cancellation-fail-transaction kupos-card content-container font11">
        <div className="font13">
          ¿Qué pudo<span className="bold-text">  haber pasado?</span>
        </div>

        <div className=" display-flex icon-text-section">
          <img src="/images/icon_timer.png" /><span>Puede que se haya agotado el tiempo de espera y la transación haya sido rechazada automáticamente.</span>
        </div>

        <div className=" display-flex icon-text-section">
          <img src="/images/icon_card.png" /><span>Puede que haya un problema con los datos de la cuenta o tarjeta que ingresaste y la transacción haya sido rechazada.</span>
        </div>

        <div className=" display-flex icon-text-section">
          <img src="/images/icon_wifi.png" /><span>Puede que hayas tenido un problema o baja conexión a Internet haciendo que la transacción fallara.</span>
        </div>

        <div className="font16 my-5">
          <span className="bold-text">¿Qué puedes hacer?</span>
        </div>

        <div className="my-3">
          En <span className="image-inside-text"> <img src="/images/kupos_logo_2.png" /> </span>estamos 100% comprometidos con entregar el mejor servicio a nuestros clientes.
          Por favor intenta comprar nuevamente o contáctanos para mayor soporte.
        </div>

        <div className=" display-flex icon-text-section">
          <img src="/images/icon_whatsapp.png" /><span>Puede que hayas tenido un problema o baja conexión a Internet haciendo que la transacción fallara.</span>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/cancellation/FailTransaction.js